if (!customElements.get('care-tips-by-metal-accordion')) {
  customElements.define(
    'care-tips-by-metal-accordion',
    class CareTipsByMetalAccordion extends HTMLElement {
      connectedCallback() {
        this._details = [...this.querySelectorAll('details')];
        this._onToggle = (event) => {
          const el = event.target;
          if (!el || el.tagName !== 'DETAILS' || !el.open) return;
          for (const d of this._details) {
            if (d !== el) d.removeAttribute('open');
          }
        };
        for (const d of this._details) {
          d.addEventListener('toggle', this._onToggle);
        }
      }

      disconnectedCallback() {
        for (const d of this._details) {
          d.removeEventListener('toggle', this._onToggle);
        }
        this._details = [];
      }
    }
  );
}
